"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const icons_1 = require("@ant-design/icons");
const antd_1 = require("antd");
const CloseIcon_1 = __importDefault(require("mdi-react/CloseIcon"));
const SearchIcon_1 = __importDefault(require("mdi-react/SearchIcon"));
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const location_icon_black_svg_1 = __importDefault(require("../../assets/images/location-icon-black.svg"));
const logo_webp_1 = __importDefault(require("../../assets/images/logo.webp"));
const menu_icon_webp_1 = __importDefault(require("../../assets/images/menu-icon.webp"));
const user_icon_white_svg_1 = __importDefault(require("../../assets/images/user-icon-white.svg"));
const auth_requests_1 = require("../../dataSource/auth_requests");
const Properties_1 = require("../../hooks/Properties");
const FacebookPixelLocation_1 = require("../facebookPixelLocation/FacebookPixelLocation");
const RoutesPaths_1 = require("../../routes/RoutesPaths");
const users_1 = require("../../utils/users");
const HeaderComponent_1 = __importDefault(require("../headerComponent/HeaderComponent"));
require("./HeaderMenuComponent.scss");
const HeaderMenuComponent = () => {
    var _a;
    const [isSearching, setIsSearching] = (0, react_1.useState)(false);
    const [menuOpened, setMenuOpened] = (0, react_1.useState)(false);
    const [subMenuOpened, setSubMenuOpened] = (0, react_1.useState)({});
    const propContext = (0, Properties_1.useProperties)();
    const [menuMobile, setMenuMobile] = (0, react_1.useState)({
        reserve: {
            menuName: 'Reserve já!',
            link: RoutesPaths_1.routesPaths.bookSuite,
            subMenus: [],
        },
        location: {
            menuName: 'Onde Estamos',
            link: '#',
            subMenus: [
                { menuName: 'Edifício 360 Luz', link: `${RoutesPaths_1.routesPaths.bookSuite}?property=["94134"]` },
                { menuName: 'Edifício 360 Higienópolis', link: `${RoutesPaths_1.routesPaths.bookSuite}?property=["127911"]` },
                { menuName: 'Edifício 360 Sé', link: `${RoutesPaths_1.routesPaths.bookSuite}?property=["94677"]` },
                { menuName: 'Edifício 360 República', link: `${RoutesPaths_1.routesPaths.bookSuite}?property=["102057"]` },
                { menuName: 'Edifício 360 Consolação', link: `${RoutesPaths_1.routesPaths.bookSuite}?property=["94862"]` },
            ],
        },
        properties: {
            menuName: 'Proprietários',
            link: RoutesPaths_1.routesPaths.landingPage,
            subMenus: [],
        },
    });
    const handleLogout = (0, react_1.useCallback)(() => {
        (0, auth_requests_1.userLogout)();
        (0, users_1.removeUserFromStorage)();
        window.location.reload();
    }, []);
    const contentUserOptions = (react_1.default.createElement("div", { className: "popover-menu-content" },
        react_1.default.createElement("div", { className: "guest-area-link" },
            react_1.default.createElement(react_router_dom_1.Link, { to: RoutesPaths_1.routesPaths.myAccount }, "\u00C1rea do h\u00F3spede")),
        react_1.default.createElement("div", { className: "logout-area", onClick: handleLogout }, "Sair")));
    (0, react_1.useEffect)(() => {
        if (propContext.properties && propContext.properties.length !== menuMobile.location.subMenus.length) {
            const subMenus = propContext === null || propContext === void 0 ? void 0 : propContext.properties.map(prop => ({
                menuName: prop.name,
                link: `${RoutesPaths_1.routesPaths.bookSuite}?property=["${prop.propId}"]`,
            }));
            setMenuMobile(Object.assign(Object.assign({}, menuMobile), { location: Object.assign(Object.assign({}, menuMobile.location), { subMenus }) }));
        }
    }, [propContext.properties, menuMobile]);
    const sendPixel = (0, react_1.useCallback)(() => {
        (0, FacebookPixelLocation_1.sendFBPixel)('ContactTrack', 'Contact');
    }, []);
    return (react_1.default.createElement(HeaderComponent_1.default, null,
        react_1.default.createElement("div", { className: "main-menu" },
            react_1.default.createElement("div", { className: "content-main-menu" },
                react_1.default.createElement("div", { className: "menu-item-container active" },
                    react_1.default.createElement(react_router_dom_1.Link, { to: RoutesPaths_1.routesPaths.root }, "Principal")),
                !isSearching ? (react_1.default.createElement("div", { className: "menu-container" },
                    react_1.default.createElement("div", { className: "menu-item-container" },
                        react_1.default.createElement(react_router_dom_1.Link, { to: RoutesPaths_1.routesPaths.bookSuite }, "Reserve j\u00E1!")),
                    react_1.default.createElement("div", { className: "menu-item-container hidden-item" },
                        react_1.default.createElement(react_router_dom_1.Link, { to: `${RoutesPaths_1.routesPaths.bookSuite}?property=["94677"]` }, "360 S\u00E9")),
                    react_1.default.createElement("div", { className: "menu-item-container hidden-item" },
                        react_1.default.createElement(react_router_dom_1.Link, { to: `${RoutesPaths_1.routesPaths.bookSuite}?property=["94134"]` }, "360 Luz")),
                    react_1.default.createElement(antd_1.Popover, { placement: "bottom", overlayClassName: "HeaderMenuComponent-popover", content: (react_1.default.createElement("div", { className: "popover-menu-content prop" }, (_a = propContext.properties) === null || _a === void 0 ? void 0 : _a.map(prop => {
                            return (react_1.default.createElement(react_router_dom_1.Link, { key: prop.propId, to: `${RoutesPaths_1.routesPaths.bookSuite}?property=["${prop.propId}"]` },
                                react_1.default.createElement("img", { src: location_icon_black_svg_1.default, alt: "" }),
                                prop.name));
                        }))), title: "" },
                        react_1.default.createElement("a", { className: "menu-popover-item noselect" }, "Onde Estamos")),
                    react_1.default.createElement("a", { href: "#goFooter", className: "menu-popover-item noselect", onClick: sendPixel }, "Fale Conosco"))) : (react_1.default.createElement("div", { className: "search-container" },
                    react_1.default.createElement(antd_1.Input, { className: "search-input", placeholder: "Buscar" }),
                    react_1.default.createElement("div", { className: "close-search" },
                        react_1.default.createElement(CloseIcon_1.default, { onClick: () => setIsSearching(!isSearching) })),
                    react_1.default.createElement("div", { className: "search-button" },
                        react_1.default.createElement(SearchIcon_1.default, { onClick: () => console.log('Search') })))))),
        react_1.default.createElement("div", { className: "login-menu" },
            react_1.default.createElement("div", { className: "owners-item" },
                react_1.default.createElement(react_router_dom_1.Link, { to: RoutesPaths_1.routesPaths.landingPage }, "Propriet\u00E1rios")),
            (0, users_1.checkUserIsAuth)() ? (react_1.default.createElement("div", { className: "login-button noselect" },
                react_1.default.createElement("img", { src: user_icon_white_svg_1.default, alt: "" }),
                react_1.default.createElement("span", null,
                    react_1.default.createElement(antd_1.Popover, { placement: "bottom", overlayClassName: "HeaderMenuComponent-popover", content: contentUserOptions, title: "", getPopupContainer: (trigger) => trigger.parentElement }, (0, users_1.getUserData)().firstName)))) : (react_1.default.createElement(react_router_dom_1.Link, { className: "login-button noselect", to: location => {
                    const lastUrl = location.pathname + location.search;
                    (0, users_1.setLastPageBeforeLogin)(lastUrl);
                    return Object.assign(Object.assign({}, location), { pathname: RoutesPaths_1.routesPaths.login });
                } },
                react_1.default.createElement("img", { src: user_icon_white_svg_1.default, alt: "" }),
                react_1.default.createElement("span", null, "Entrar"))),
            react_1.default.createElement("div", { className: "menu-icon-mobile", onClick: () => setMenuOpened(!menuOpened), role: "presentation" },
                react_1.default.createElement("img", { src: menu_icon_webp_1.default, alt: "" }))),
        react_1.default.createElement("div", { className: `menu-mobile-container ${menuOpened ? 'menu-mobile-opened' : ''}` },
            react_1.default.createElement("div", { className: "menu-mobile" },
                react_1.default.createElement("div", { className: "logo-mobile-container" },
                    react_1.default.createElement(react_router_dom_1.Link, { className: "logo-img", to: "#" },
                        react_1.default.createElement("img", { src: logo_webp_1.default, alt: "" })),
                    react_1.default.createElement(icons_1.CloseOutlined, { onClick: () => setMenuOpened(false) })),
                react_1.default.createElement("div", null, Object.values(menuMobile).map((menuItem, menuIdx) => {
                    const menuKey = `menuKey-${menuIdx}`;
                    if (!menuItem.subMenus.length) {
                        return (react_1.default.createElement("div", { key: menuKey, className: "mobile-menu-item mobile-menu-item-single" },
                            react_1.default.createElement("a", { href: menuItem.link }, menuItem.menuName)));
                    }
                    return (react_1.default.createElement("div", { key: menuKey, className: "mobile-menu-item mobile-menu-item-sub" },
                        react_1.default.createElement("div", { className: "mobile-menu-item-text", onClick: () => {
                                setSubMenuOpened(Object.assign(Object.assign({}, subMenuOpened), { [menuKey]: !subMenuOpened[menuKey] }));
                            }, role: "presentation" },
                            menuItem.menuName,
                            subMenuOpened[menuKey] ? react_1.default.createElement(icons_1.CaretUpOutlined, null) : react_1.default.createElement(icons_1.CaretDownOutlined, null)),
                        react_1.default.createElement("div", { style: subMenuOpened[menuKey] ? { maxHeight: `${menuItem.subMenus.length * 26}vh` } : { maxHeight: '0' }, className: "submenu-container" }, menuItem.subMenus.map((subMenuItem) => (react_1.default.createElement("div", { key: subMenuItem.menuName, className: "mobile-submenu-item" },
                            react_1.default.createElement("a", { href: subMenuItem.link }, subMenuItem.menuName)))))));
                })),
                (0, users_1.checkUserIsAuth)() ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "user-name-mobile" },
                        react_1.default.createElement("img", { src: user_icon_white_svg_1.default, alt: "" }),
                        (0, users_1.getUserData)().firstName),
                    react_1.default.createElement("div", { className: "guest-area-link" },
                        react_1.default.createElement(react_router_dom_1.Link, { to: RoutesPaths_1.routesPaths.myAccount }, "\u00C1rea do h\u00F3spede")),
                    react_1.default.createElement("div", { className: "logout-area", onClick: handleLogout }, "Sair"))) : (react_1.default.createElement("div", { className: "login-mobile" },
                    react_1.default.createElement(react_router_dom_1.Link, { className: "login-button noselect", to: location => {
                            const lastUrl = location.pathname + location.search;
                            (0, users_1.setLastPageBeforeLogin)(lastUrl);
                            return Object.assign(Object.assign({}, location), { pathname: RoutesPaths_1.routesPaths.login });
                        } },
                        react_1.default.createElement("span", null, "Entrar"))))))));
};
exports.default = HeaderMenuComponent;
